import { openDialog } from '@/components/basic-components/dialog/create-dialog';
import Loading from './loading.vue';
import Confirm from './confirm.vue';
import Reject from './reject.vue';
import Accept from './accept.vue';
import CreateAccount from './create-account.vue';
import UpdateEmail from './update-email.vue';
import UpdatePassword from './update-password.vue';
import type { ConfirmModalProps } from './confirm-types';
import type { RejectDialogProps } from './reject-types';
import type { AcceptDialogProps } from './accept-types';
import GoogleMapDialog from './google-map-dialog.vue';
import NoAccessPermission from './no-access-permission.vue';
import type { NoAccessPermissionModalProps } from './no-access-permission-types';

export function openLoadingModal(props: any) {
  const options = {
    props: props,
  }
  return openDialog(Loading, options)
}

export function openConfirmModal(props: ConfirmModalProps) {
  const options = {
    props: props,
  }
  return openDialog(Confirm, options)
}
export function openGoogleMapDialog(props?: any) {
  const options = {
    props: props || {},
    rootProps: {
      zIndex: 3001,
    }
  }
  return openDialog(GoogleMapDialog, options)
}
export function openRejectModal(props: RejectDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(Reject, options)
}

export function openAcceptModal(props: AcceptDialogProps) {
  const options = {
    props: props,
  }
  return openDialog(Accept, options)
}

export function openCreateAccountModal(props: any) {
  const options = {
    props: props,
  }
  return openDialog(CreateAccount, options)
}

export function openUpdateEmailModal(props: any) {
  const options = {
    props: props,
  }
  return openDialog(UpdateEmail, options)
}

export function openUpdatePasswordModal(props: any) {
  const options = {
    props: props,
  }
  return openDialog(UpdatePassword, options)
}

export function openNoAccessPermissionModal(props?: NoAccessPermissionModalProps) {
  const options = {
    props: props || {},
  }
  return openDialog(NoAccessPermission, options)
}

export type { ConfirmModalProps, ButtonConfig, ButtonType } from './confirm-types';
export type { RejectDialogProps } from './reject-types';
export type { AcceptDialogProps } from './accept-types';
export type { NoAccessPermissionModalProps } from './no-access-permission-types';